import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { useProgramElapsedSeconds } from '../../../hooks/dashboard/useProgramElapsedSeconds';
import { formatElapsedDurationSeconds } from '../../../utils/formatElapsedDuration';
import { useWidgetHeader } from './WidgetHeaderContext';
import { TimerDurationDisplay } from './TimerDurationDisplay';

interface TimerWidgetProps {
  dataKey: string;
}

const TimerWidget = ({ dataKey }: TimerWidgetProps) => {
  const { t } = useTranslation();
  const programElapsedSeconds = useProgramElapsedSeconds();
  const elapsedSeconds = dataKey === 'program' ? programElapsedSeconds : 0;
  const time = formatElapsedDurationSeconds(elapsedSeconds);

  const headerTitle = useMemo(() => t('TimerWidget.title', 'Timer'), [t]);

  useWidgetHeader({ title: headerTitle }, [headerTitle]);

  return <TimerDurationDisplay time={time} ariaLabel={t('TimerWidget.aria.elapsed', { defaultValue: 'Program elapsed time {{time}}', time })} />;
};

export default TimerWidget;
